import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

/**
 * ConfirmDeleteModal — Soft-delete confirmation dialog.
 *
 * Usage:
 *   // Single delete
 *   ConfirmDeleteModal({
 *     title: "Delete Rider",
 *     content: "Are you sure you want to delete this rider?",
 *     onConfirm: () => handleDelete(id),
 *   });
 *
 *   // Bulk delete
 *   ConfirmDeleteModal({
 *     title: "Delete Riders",
 *     count: selectedIds.length,
 *     onConfirm: () => handleBulkDelete(selectedIds),
 *   });
 */
export default function ConfirmDeleteModal({
  title = "Confirm Delete",
  content,
  count,
  onConfirm,
}) {
  const message = content
    || (count
      ? `Are you sure you want to delete ${count} selected record${count > 1 ? "s" : ""}? This action cannot be undone.`
      : "Are you sure you want to delete this record? This action cannot be undone.");

  Modal.confirm({
    title,
    icon: <ExclamationCircleOutlined />,
    content: message,
    okText: "Delete",
    okType: "danger",
    cancelText: "Cancel",
    onOk: onConfirm,
  });
}
